import * as React from 'react';

import * as styles from './diversity.css';

export const Diversity: React.SFC<{}> = () => {
  return (
    <section className={styles.diversityContainer}>
      <div className={styles.content}>
        <h1>Diversity and Inclusion</h1>
        <p>
          Our people are our greatest asset. We know that the best products are created by teams
          that encourage and embrace input from all perspectives. Diversity is essential to our
          mission. We are committed to fostering an environment that celebrates dialogue and remains
          focused on each and every individual's personal and career growth.
        </p>

        <div className={styles.principle}>
          <div className={styles.quote}>
            We offer our people the opportunity to move ahead more rapidly than is possible at most
            other places. Advancement depends on merit and we have yet to find the limits to the
            responsibility our best people are able to assume. For us to be successful, our men and
            women must reflect the diversity of the communication and cultures in which we operate.
            That means we must attract, retain and motivate people from many backgrounds and
            perspectives. <span>Being diverse is not optional; it is what we must be.</span>
            <p>Business Principle #7</p>
          </div>
        </div>
      </div>
    </section>
  );
};
